import { Icon, Menu } from "@mindlercare/ui-web";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Typography } from "components/typography";
import { CalendarTemplatesSettingsDialog } from "../../CalendarTemplates/CalendarTemplatesSettings";
import { useWeekTemplates } from "../../hooks/useWeekTemplates";
import { CalendarSettingsDialog } from "./CalendarSettingsDialog";
import { SubscribeToCalenderItem } from "./SubscribeToCalendar";
import { useFlag } from "@mindlercare/unleash-client";

type CalendarMenuItem =
  | "CALENDAR_SETTINGS"
  | "SUBSCRIBE_TO_CALENDAR"
  | "CALENDAR_WEEK_TEMPLATES";

export const CalendarActionsMenu = () => {
  const { t } = useTranslation();
  const [openDialog, setOpenDialog] = useState<CalendarMenuItem | null>(null);
  const isWeekScheduleEnabled = useWeekTemplates();
  const isSubscribeToCalendarEnabled = useFlag(
    "SUBSCRIBE_PSYCHOLOGIST_CALENDAR",
  );

  const closeDialog = () => setOpenDialog(null);

  return (
    <>
      <Menu>
        <Menu.Trigger variant="icon">
          <Icon.Settings />
        </Menu.Trigger>
        <Menu.Items>
          <Menu.Item
            onClick={() => {
              setOpenDialog("CALENDAR_SETTINGS");
            }}
          >
            <Typography variant="body-small" insensitive>
              {t("CALENDAR_SETTINGS")}
            </Typography>
          </Menu.Item>
          {isSubscribeToCalendarEnabled && (
            <Menu.Item
              onClick={() => {
                setOpenDialog("SUBSCRIBE_TO_CALENDAR");
              }}
            >
              <Typography insensitive variant="body-small">
                {t("SUBSCRIBE_TO_CALENDAR")}
              </Typography>
            </Menu.Item>
          )}
          {isWeekScheduleEnabled && (
            <Menu.Item onClick={() => setOpenDialog("CALENDAR_WEEK_TEMPLATES")}>
              <Typography variant="body-small">
                {t("CALENDAR_WEEK_TEMPLATES_MODAL_TITLE")}
              </Typography>
            </Menu.Item>
          )}
        </Menu.Items>
      </Menu>
      <CalendarSettingsDialog
        open={openDialog === "CALENDAR_SETTINGS"}
        close={closeDialog}
      />
      {isWeekScheduleEnabled && (
        <CalendarTemplatesSettingsDialog
          open={openDialog === "CALENDAR_WEEK_TEMPLATES"}
          close={closeDialog}
        />
      )}
      {isSubscribeToCalendarEnabled && (
        <SubscribeToCalenderItem
          open={openDialog === "SUBSCRIBE_TO_CALENDAR"}
          close={closeDialog}
        />
      )}
    </>
  );
};
